export default {
    name: 'RelatedPatrons',


    /**
     * @override
     */
    data() {
        return {
            patrons: [],
            fields: [
                {
                    key: 'given_name',
                    label: 'Nombre'
                },
                {
                    key: 'family_name',
                    label: 'Apellidos'
                },
                {
                    key: 'document_id',
                    label: 'Nº de documento'
                },
                {
                    key: 'percent',
                    label: 'Porcentaje'
                }
            ],
            showForm: false
        };
    },
    props: {
        id: {
            type: String,
            required: false
        }
    },
    methods: {
        fetchData() {
            this.$accountsService.getAccountPatrons(this.id)
                .then(response => {
                    this.patrons = response.data.account_patrons;
                })
                .catch(error => console.error(error));
        }
    },

    /**
     * @override
     */
    beforeMount() {
        this.fetchData();
    }
};
